<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8">
          <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Search</label>
              <vs-input type="text" v-model="filters['search']" class="w-full" />
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                v-on:click="filters = {}">CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="CHANNEL PARTNERS">
          <template slot="actions">
            <div class="flex">
              <!-- <vs-button @click.stop="onClickCreate">Create</vs-button> -->
            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table id="suppliers-table" :max-items="(meta.per_page) ? meta.per_page : 10" :data="rm_suppliers"
              @sort="handleSort" :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-td width="10%">CHANNEL PARTNER CODE</vs-td>
                <vs-th width="15%" sort-key="company_name">COMPANY NAME</vs-th>
                <vs-th width="15%">FIRST NAME</vs-th>
                <vs-th width="15%">LAST NAME</vs-th>
                <vs-th width="15%" class="">EMAIL</vs-th>
                <vs-th width="15%" class="">STATUS</vs-th>
                <vs-th width="15%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" @click.native="onClickSupplierView(data[indextr].id)" :key="indextr"
                  v-for="(tr, indextr) in data">

                  <vs-td>
                    {{ data[indextr].code }}
                  </vs-td>

                  <vs-td :data="data[indextr].company_name">
                    {{ data[indextr].company_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].first_name">
                    {{ data[indextr].first_name || 'N/A' }}
                  </vs-td>

                  <vs-td :data="data[indextr].last_name">
                    {{ data[indextr].last_name || 'N/A' }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].email || 'N/A' }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].status }}
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View / Edit" position="left">
                        <vs-button class="ml-3" @click="onClickSupplierView(data[indextr].id)" size="small"
                          color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
              description :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
              v-model="page" class="p-5">
            </vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <createChannelPartnerPopUp ref="createChannelPartnerPopUp"/>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const ChannelPartnerRepository = RepositoryFactory.get('channel_partner')
import { defaultPagination, perPageList } from "@/constants/config";
import CreateChannelPartnerPopUp from '@/components/popups/tenants/channel-partners/CreateChannelPartnerPopUp.vue';

export default {
  name: 'ChannelPartnersList',
  data() {
    return {
      rm_suppliers: [],
      departments: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      supplier_status_list: [
        { name: 'SAQ Pending', value: 1 },
        { name: 'Pending Approval', value: 2 },
        { name: 'Approved', value: 3 },
        { name: 'Not Approved', value: 4 },
        { name: 'On Hold', value: 5 },
      ],
      tenant_id: ''
    }
  },
  components: {
    'v-select': vSelect,
    CreateChannelPartnerPopUp
  },
  mixins: [Filter],
  async mounted() {
    this.tenant_id = this.$route.params.id
  },
  methods: {
    async refreshData() {
      this.loadRmSuppliers()
    },

    async loadRmSuppliers() {
      await this.$vs.loading({
        container: '#suppliers-table',
        scale: 0.45
      })
      const { data } = await ChannelPartnerRepository.getChannelPartnerList(this.page, this.filterQuery, this.perPage, this.sort, this.tenant_id)
      this.rm_suppliers = data.data
      this.meta = data.meta
      this.$vs.loading.close('#suppliers-table > .con-vs-loading')
    },
    openConfirm() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Remove Confirm',
        text: 'Are you sure you want to permanently remove this organization?',
        accept: this.acceptAlert
      })
    },

    acceptAlert() {
      this.$vs.notify({
        color: 'danger',
        title: 'Deleted Organization',
        position: 'top-right',
        text: 'The selected organization was successfully deleted'
      })
    },
    async onClickSupplierView(id) {
      // const url = `/pages/tenants/${this.tenant_id}/suppliers/${id}`;
      // const newTab = window.open(url, '_blank');
      // newTab.focus();
      this.$router.push({ path: `/pages/tenants/${this.tenant_id}/channel-partners/${id}` })
    },
    filterQueryUpdate() {
      this.loadRmSuppliers()
    },

    handleChangePage(page) {
      this.page = page;
      this.loadRmSuppliers()
    },

    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.loadRmSuppliers()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    async onClickCreate() {
      await this.$refs.createChannelPartnerPopUp.openPopup()
    }

  },
  watch: {
    page() {
      this.loadRmSuppliers()
    },
    perPage() {
      this.loadRmSuppliers()
    }
  }
}
</script>
